function compare(post, operator, value) {
  switch (operator) {
    case ">":
      return post > value;
    case "<":
      return post < value;
    case ">=":
      return post >= value;
    case "<=":
      return post <= value;
    case "==":
      return post == value;
    case "!=":
      return post != value;
    case "===":
    case "is":
      return post === value;
    case "!==":
      return post !== value;
    case "presence":
      return post;
  }
}

function validate(fieldData, validations, data) {
  let isInvalid = false;
  let errorMessages = [];

  Object.keys(validations).forEach((key) => {
    let failed = false;
    let regexField;
    let comparedProperty;
    let lengthValue;
    let lengthOperator;
    const fieldObject = validations[key];

    if ("patternValue" in fieldObject) {
      regexField = new RegExp(fieldObject.patternValue);
    } else if ("patternProperty" in fieldObject) {
      regexField = new RegExp(data[fieldObject.patternProperty]);
    }
    if (key === "comparison") comparedProperty = fieldObject.property;
    if (key === "length") {
      lengthValue = fieldObject.value;
      lengthOperator = fieldObject.operator;
    }

    switch (key) {
      case "empty":
        failed = !fieldData;
        break;
      case "date":
        failed =
          fieldData &&
          new Date(fieldData + "T00:00:00") <
            new Date(
              new Date().toLocaleDateString("en-CA", {
                timeZone: data.store_timezone,
              }) + "T00:00:00",
            );
        break;
      case "pattern":
        failed = !regexField.test(fieldData);
        break;
      case "comparison":
        failed = compare(fieldData, "!==", data[comparedProperty]);
        break;
      case "length":
        failed = !compare(fieldData.length, lengthOperator, lengthValue);
        break;
    }

    if (failed) {
      isInvalid = true;
      errorMessages.push(validations[key].errorMessageKey);
    }
  });

  return { invalid: isInvalid, errorMessages: errorMessages };
}

const ValidateForm = (formValidationRules, data) => {
  let isValid = true;
  let currentErrors = {};

  Object.keys(formValidationRules.fields).forEach((key) => {
    let conditions = formValidationRules.fields[key].conditions;
    let validations = formValidationRules.fields[key].validations;

    if (conditions && conditions.length > 0) {
      let applicableValidation = true;
      let conditionsResults = [];

      conditions.forEach((condition, i) => {
        let expressionsResults = [];
        let result;

        if ("expressions" in condition) {
          condition.expressions.forEach((item, i) => {
            let post;
            if ("subproperty" in item) {
              post = data[item.property]
                ? data[item.property][item.subproperty]
                : data[item.property];
            } else {
              post = data[item.property];
            }

            let outcome = compare(post, item.operator, item.value);

            expressionsResults.push(outcome);
          });

          if (expressionsResults.length > 1) {
            result = eval(
              expressionsResults.join(` ${condition.logicalOperator} `),
            );
          } else {
            result = expressionsResults[0];
          }

          conditionsResults.push(result);
        } else {
          conditionsResults.push(condition.logicalOperator);
        }
      });

      let conditionsStatement = conditionsResults.join(" ");
      applicableValidation = eval(conditionsStatement);

      if (applicableValidation) {
        let validationResults = validate(data[key], validations, data);

        if (validationResults.invalid) {
          currentErrors[key] = validationResults.errorMessages[0];
          isValid = false;
        }
      }
    } else {
      let validationResults = validate(data[key], validations, data);

      if (validationResults.invalid) {
        currentErrors[key] = validationResults.errorMessages[0];
        isValid = false;
      }
    }
  });

  return { status: isValid, errors: currentErrors };
};

export default ValidateForm;
